import React from 'react';
import styled from 'styled-components';

import { NavigationLink } from '../types/navigationLink';
import { ColorScheme } from '../config/colorSchemes';
import Button from './Button';
import { ButtonProps } from '../types/button';

type gapSize = 'xsmall' | 'small' | 'base' | 'large' | 'xlarge';
const sizeMap: Record<gapSize, string> = {
  xsmall: 'var(--spacing-xsmall)',
  small: 'var(--spacing-small)',
  base: 'var(--spacing-base)',
  large: 'var(--spacing-large)',
  xlarge: 'var(--spacing-xlarge)',
};

const LinkStyles = styled.ul<{ $vertical: boolean; $gap: gapSize }>`
  display: flex;
  flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')};
  gap: ${({ $gap }) => sizeMap[$gap]};
`;

interface LinkProps {
  links: NavigationLink[];
  vertical?: boolean;
  gap?: gapSize;
  buttonStyles?: ButtonProps;
  onClick?: () => void;
  children?: React.ReactNode;
  target?: string;
  rel?: string;
}

const Links: React.FC<LinkProps> = ({
  links,
  vertical = false,
  gap = 'base',
  buttonStyles,
  onClick,
  children,
  target,
  rel,
}) => {
  return (
    <LinkStyles $vertical={vertical} $gap={gap}>
      {links.map(({ label, to, iconName, iconColour }) => (
        <li key={`${to} li`}>
          <Button
            key={`${to} button`}
            href={to}
            text={label}
            onClick={onClick}
            {...(iconName && { iconName })}
            {...(iconColour && { iconColour })}
            {...buttonStyles}
            {...(target ? { target } : {})}
            {...(rel ? { rel } : {})}
          />
        </li>
      ))}
      {children}
    </LinkStyles>
  );
};

export default Links;
